<template>
  <v-container fill-height>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="card" color="primary">
          <v-card-title class="justify-center font-weight-bold">Buscar personal</v-card-title>
          <v-card-text>
            <BaseInput v-model="busquedaPersonal.nombre" label="Nombre"></BaseInput>
            <BaseInput v-model="busquedaPersonal.segundoNombre" label="Segundo nombre"></BaseInput>
            <BaseInput v-model="busquedaPersonal.apaterno" label="Apellido paterno"></BaseInput>
            <BaseInput v-model="busquedaPersonal.amaterno" label="Apellido materno"></BaseInput>
            <BaseInput v-model="busquedaPersonal.curp" label="CURP"></BaseInput>
            <BaseInput v-model="busquedaPersonal.CUIP" label="CUIP"></BaseInput>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton @click="triggerSearchPersonal()" :disabled="loading || emptyForm" :loading="loading">
                    Realizar búsqueda
                  </TextButton>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <v-btn color="secondary" rounded @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <BaseInput label="Filtrar elementos" v-model="filtroPersonal"></BaseInput>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="card" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!personal.foto">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.foto = null"
                  ></v-img>
                </v-col>
                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <div class="text-subtitle-1 primary--text">
                    Adscripción:
                    {{
                      personal.CatPuestoDependencia.catDependencia.nombre
                        ? personal.CatPuestoDependencia.catDependencia.nombre
                        : 'Sin adscripción'
                    }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="secondary darken-1">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        :to="{ name: 'asignaEquipamiento', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-briefcase-plus</v-icon></v-btn
                      >
                    </template>
                    <span>Asignar equipamiento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        :to="{ name: 'historicoRegistroEquipamiento', params: { id: personal.idPersonal } }"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-list-box-outline</v-icon></v-btn
                      >
                    </template>
                    <span>Historico de asignacion del equipamiento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text mx-2"
                        elevation="8"
                        icon
                        @click="generarConstanciaNoAdeudoAntimotin(personal)"
                        v-on="on"
                        v-bind="attrs"
                        ><v-icon>mdi-file-word</v-icon></v-btn
                      >
                    </template>
                    <span>Constancia de No Adeudo Antimotin</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
<script>
import { Packer } from 'docx'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import BaseInput from '@src/components/base/BaseInput.vue'
import TextButton from '@src/components/base/TextButton.vue'
import FormatoNoAdeudoAntimotin from '@src/utils/doc-generator/armeria/FormatoNoAdeudoAntimotin'

export default {
  components: {
    BaseInput,
    TextButton,
  },
  data() {
    return {
      loading: false,
      filtroPersonal: '',
    }
  },

  computed: {
    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },

    download: function (id) {
      window.open(
        'http://ssctlaxcala.eonproduccion.net/tableros/report.php?r=59&u1=' +
          id +
          '&m=1&h=5254dbdeb51eb0435529a6af6dbace7362bdf4db',
        '_blank'
      )
    },

    downloadCartaNoAdeudo: function (cuip) {
      window.open(
        'http://ssctlaxcala.eonproduccion.net/tableros/report.php?r=68&u1=' +
          cuip +
          '&m=1&h=9ae897093104fc9734a959dfb66811f15f7cc110&export=pdf',
        '_blank'
      )
    },

    async generarConstanciaNoAdeudoAntimotin(personal) {
      const nombreCompleto = [personal.apaterno, personal.amaterno, personal.nombre, personal.segundoNombre || '']
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim()

      const puesto = personal.CatPuestoDependencia?.catPuesto?.title || 'SIN PUESTO'
      const fecha = new Date().toISOString().slice(0, 10)

      const doc = new FormatoNoAdeudoAntimotin({
        nombre: nombreCompleto,
        puesto: puesto,
        fecha: fecha,
      })
      const newDoc = await doc.generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `FormatoNoAdeudoAntimotin_${nombreCompleto}.docx`
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
